module.exports = __webpack_public_path__ + "img/heart.4ac2248e.png";